export default {
    translation: {
        sidebar: {
            btnHome: 'Trang chủ',
            btnLogin: 'Đăng nhập',
            btnRegister: 'Đăng ký',
            btnUpdateUserInfo: 'Cập nhật thông tin',
            btnAddressMgr: 'Quản lý địa chỉ',
            btnUpdatePassword: 'Cập nhật mật khẩu',
            btnLogout: 'Đăng xuất',

            lbNotLogin: 'Chưa đăng nhập',
        },
        shortcutCartMobile: {
            btnOpenMenu: 'Menu',
            btnCloseMenu: 'Đóng',

            lbDishCount1: '{{count}} món',
            lbDishCountn: '{{count}} món',

            orderNew: '{{count}} new'
        },
        foodMobile: {
            btnAdd: 'Thêm',
            btnNote: 'Ghi chú',
            btnMoreInfo: 'Thông tin thêm',
            btnSeeMore: 'Xem thêm',
            btnCollapse: 'Thu gọn',
            soldOut: 'Hết hàng',

            lbOptional: 'Tuỳ chọn',
            lbDishCount1: '{{count}} món',
            lbDishCountn: '{{count}} món',
        },
        headerMobile: {
            lbSearchFood: 'Tìm món ...',
        },
        modalNoteMobile: {
            title: 'Thêm ghi chú',

            btnSave: 'Lưu',
        },
        modalFastEditMobile: {
            btnAddOther: 'Thêm món tuỳ chỉnh khác',
            btnChange: 'Thay đổi',
            btnOK: 'OK',

            lbDefault: 'Mặc định',
        },
        modalFoodDetailsMobile: {
            btnAddToCart: 'Thêm vào giỏ',
            btnUpdateCart: 'Cập nhật giỏ',

            lbNote: 'Ghi chú',
        },
        modalMoreInfo: {
            title: 'Thông tin thêm',
        },
        modalOrderMethod: {
            title: 'Phương thức đặt hàng',
            titleSearchAddress: 'Địa chỉ của bạn',

            lbDeliver: 'Giao hàng',
            lbPickup: 'Đến cửa hàng',
            lbHadAccount: 'Bạn đã có tài khoản',
            lbAddressSaved: 'Địa chỉ đã lưu',

            mesWebOrderUnSupport: 'Dịch vụ đặt hàng trực tuyến không hỗ trợ.',
            mesOutsideShippingSupportArea: 'Chúng tôi chỉ giao hàng trong phạm vi {{distance}}km.\nHãy gọi điện thoại cho chúng tôi để đặt hàng!',

            btnNext: 'Tiếp theo',
        },
        modalTableOrderMethod: {
            title: 'Chọn phương thức',

            lbAtRestaurant: 'Ăn tại nhà hàng',
            lbTakeAGo: 'Mang đi',
        },
        modalOverTime: {
            message: 'Ngoài giờ mở cửa',
            btnAgree: 'Đồng ý',
            messageNotReady: 'Chúng tôi sẽ hoạt động lại sớm!',
            messageTodayOff: 'Hôm nay chúng tôi đóng cửa.',
            messageTimeworkFrame1: 'Ngoài giờ mở cửa.\nChúng tôi mở cửa\ntừ {{from}}h đến {{to}}h.',
            messageTimeworkFrame2: 'Ngoài giờ mở cửa.\nChúng tôi mở cửa\ntừ {{from1}}h đến {{to1}}h và từ {{from2}}h đến {{to2}}h.'
        },
        modalPayWithPaypal: {
            title: 'Thanh toán bằng Paypal',
            btnPayWithCash: 'Tiền mặt',
            btnPayWithEC: 'EC',
        },
        modalExpireOrderSession: {
            message: 'Phiên đặt hàng hết hạn, vui lòng scan lại QRCode',
            title: 'Thông báo',
            btnAgree: 'Đồng ý',
        },
        cartMobile: {
            title: 'Giỏ hàng',

            lbTotalAmount: 'Tổng tiền',
            lbTableNumber: 'Số bàn',
            lbCartEmpty: 'Giỏ hàng trống',
            lbCash: 'Tiền mặt',
            lbCashCard: 'Dùng thẻ',
            lbDeliver: 'Giao hàng',
            lbPickup: 'Đến cửa hàng',
            lbOrderMethod: 'Phương thức đặt hàng',
            lbCustomerName: 'Tên khách hàng',
            lbNote: 'Ghi chú',
            lbSelectDeliverTime: 'Chọn thời gian giao',
            lbPayWithEC: 'EC',
            lbGroupOrder: 'Nhóm {{group}}',
            lbShippingPrice: 'Phí giao hàng',

            btnStartOrder: 'Mua hàng',
            backToMenu: 'Quay lại menu',
            btnSubmitOrder: 'Đặt hàng',
            btnRequestPayment: 'Yêu cầu thanh toán',
            btnAddGroupOrder: 'Nhóm mới',

            mesRequestPaymentSuccess: 'Yêu cầu thanh toán thành công',
            mesRequestSupportSuccess: 'Gọi nhân viên hỗ trợ thành công',
            mesMinTotalMoneyRequire:
                'Tổng tiền đơn hàng không được nhỏ hơn {{minValue}}',
            mesSubmitOrderTakeAGoSuccess:
                'Cảm ơn quý khách, đơn hàng đã đặt thành công.',
        },
        modalOrderSuccess: {
            titleSubmitOrderSuccess: 'Đặt hàng thành công',
            titleRestaurantDoneOrder: 'Đơn hàng hoàn tất',
            titleProcessing: 'Đang chuẩn bị',
            titleAccepted: 'Đã tiếp nhận',
            titleFailed: 'Đơn hàng đã bị huỷ',

            lbTotal: 'Tổng tiền',
            lbShippingPrice: 'Phí giao hàng',

            mesSubmitOrderWebSuccess:
                'Cảm ơn quý khách, đơn hàng đã đặt thành công.',
            mesSubmitOrderSuccess: 'Đặt hàng thành công',
            mesAccepted: 'Đơn hàng của quý khách đã được nhà hàng tiếp nhận.',
            mesProcessing: 'Đơn hàng của bạn đang được chuẩn bị, vui lòng đợi.',
            mesDonePickup:
                'Đơn hàng của quý khách đã hoàn tất, quý khác vui lòng tới nhà hàng để nhận đơn hàng',
            mesDoneDeliver: 'Đơn hàng của quý khách đang được giao',
            mesDoneAtRestaurant:
                'Đơn hàng của quý khác đã được nhà hàng chuẩn bị xong, quý khách vui lòng tới quầy để nhận hàng.',
            mesFailed: 'Đơn hàng của quý khách đã bị hủy.',
            mesTabletDoneSubmit: 'Vui lòng tới quầy thanh toán.',

            lbDiscount: 'Mã giảm giá',
            hintDontCloseTab: 'Vui lòng không đóng cửa sổ này!',
        },
        footer: {
            lbContact: 'Liên hệ',
            lbCopyright: '© Copyright 2021. All rights reserved by {{someone}}',
            lbImprint: 'Impressum'
        },
        cartDesktop: {
            title: 'Giỏ hàng',

            lbCartEmpty: 'Giỏ hàng trống',
            lbAgreeTCPre: 'Bằng việc bấm vào đặt món, bạn đông ý với các',
            lbAgreeTCRest: 'bảo vệ dữ liệu của chúng tôi',
            lbTermAndCondition: 'Điều khoản và điều kiện',
            lbDeliver: 'Giao hàng',
            lbPickup: 'Đến cửa hàng',
            lbOrderMethod: 'Phương thức đặt hàng',
            lbTotalAmount: 'Tổng tiền',
            lbCash: 'Tiền mặt',
            lbPaymentMethod: 'Phương thức thanh toán',
            lbCustomerName: 'Tên khách hàng',
            lbDeliverInfo: 'Thông tin giao hàng',
            lbNote: 'Ghi chú',
            lbSelectDeliverTime: 'Chọn thời gian giao',
            lbOrderNote: 'Ghi chú cho toàn bộ đơn hàng',
            lbPayWithEC: 'EC',
            lbShippingPrice: 'Phí giao hàng',

            mesRestaurantDoneOrder:
                'Đơn hàng của quý khác đã được nhà hàng chuẩn bị xong, quý khách vui lòng tới quầy để nhận hàng.',
            mesRequestPaymentSuccess: 'Yêu cầu thanh toán thành công',
            mesRequestSupportSuccess: 'Gọi nhân viên hỗ trợ thành công',
            mesMinTotalMoneyRequire:
                'Tổng tiền đơn hàng không được nhỏ hơn {{minValue}}',

            btnStartOrder: 'Mua hàng',
            btnSubmitOrder: 'Đặt hàng',
            btnAddGroupOrder: 'Nhóm mới',
            btnAgree: 'Đồng ý',
            btnCancel: 'Hủy',
        },
        headerDesktop: {
            btnUpdateUserInfo: 'Cập nhật thông tin',
            btnUpdatePassword: 'Cập nhật mật khẩu',
            btnLogout: 'Đăng xuất',
            btnLogin: 'Đăng nhập',
            btnRegister: 'Đăng ký',
            btnAddressMgr: 'Quản lý địa chỉ',
        },
        button: {
            agree: 'Đồng ý',
            update: 'Cập nhật',
            register: 'Đăng ký',
            forgotPassword: 'Quên mật khẩu',
            login: 'Đăng nhập',
            confirm: 'Xác nhận',
            moreInfo: 'Thông tin thêm',
            startOrder: 'Mua hàng',
            requestPayment: 'Yêu cầu thanh toán',
            back: 'Quay lại',
        },
        voucher: {
            discountCode: 'Mã giảm giá',
            btnVerify: 'Xác thực',
            verified: 'Đã xác thực',
            invalidVoucher: 'Mã giảm giá không hợp lệ',
            minOrderNotMet: 'Đơn hàng tối thiểu {{minValue}} để sử dụng mã này',
            voucherVerified: 'Mã giảm giá đã được chấp nhận!',
            voucherDetails: 'Chi tiết voucher',
        },
        customerInfo: {
            username: 'Tên đăng nhập',
            password: 'Mật khẩu',
            confirmPassword: 'Xác nhận mật khẩu',
            newPassword: 'Mật khẩu mới',
            confirmNewPassword: 'Xác nhận mật khẩu mới',
            firstName: 'Tên',
            phone: 'Số điện thoại',
            email: 'Email',
            office: 'Văn phòng',
            street: 'Đường',
            apartmentNumber: 'Số nhà',
            postCode: 'Mã bưu điện',
            city: 'Thành phố',
            floor: 'Tầng toà nhà',
            address: 'Địa chỉ',
            personalInformation: 'Dữ liệu cá nhân',
            contactInfo: 'Thông tin liên hệ',
            otp: 'OTP',
            cash: 'Tiền mặt',
            card: 'Dùng thẻ',
            cash_card: 'Dùng thẻ',
            delivery: 'Giao hàng',
            pickup: 'Tới lấy',
            deliveryTime: 'Thời gian giao',
            pickupTime: 'Thời gian đến lấy',
            paymentMethod: 'Phương thức thanh toán',
            payment: 'Thanh toán',

            lbSelectAddress: 'Chọn địa chỉ',
            lbDefaultSelectAddress: 'Chọn địa chỉ',
            paymentMethodGroupCash: 'Trực tiếp',
            paymentMethodGroupOnline: 'Trực tuyến',
        },
        // for mobile page and desktop modal
        updatePassword: {
            title: 'Cập nhật mật khẩu',
        },
        // page and modal
        forgotPassword: {
            title: 'Quên mật khẩu',
            titleNewPassword: 'Mật khẩu mới',

            mesChangeSuccess: 'Cập nhật mật khẩu thành công',
        },
        // register page and update personal info page
        personalInfo: {
            titleRegister: 'Đăng ký',
            titleUpdate: 'Cập nhật thông tin',
        },
        orderDetails: {
            totalAmount: 'Tổng tiền',
        },
        orderHistory: {
            code: 'Mã',
            lbWaitingConfirm: 'Chờ xác nhận',
        },
        modalFoodChoose: {
            title: 'Chọn món',
            btnAgree: 'Đồng ý',
        },
        message: {
            minTotalMoneyRequire:
                'Tổng tiền đơn hàng không được nhỏ hơn {{minValue}}',
            mesOutsideShippingSupportArea: 'Chúng tôi chỉ giao hàng trong phạm vi {{distance}}km.\nHãy gọi điện thoại cho chúng tôi để đặt hàng!',
            messageInvalidTable:
                'Bàn không thể đặt được, vui lòng liên hệ chủ cửa hàng',
            tabletQRCodeScannedBySomeone:
                'QRcode đã được scan bởi người khác, vui lòng thử scan lại bằng mã khác',
            beilageRequire: 'Nhóm {{group}} phải chọn tối thiểu một',
            waiting: 'Đang tải vui lòng chờ',
            invalidTable: 'Bàn không hợp lệ, vui lòng scan lại QRCode',
            registerSuccess: 'Đăng ký thành công',
            updateUserInfoSuccess: 'Cập nhật thành công',
            invalidAddress: 'Địa chỉ không hợp lệ',
            invalidRestaurant: 'Nhà hàng không hợp lệ',
            invalidEmail: 'Email không hợp lệ',
            fieldRequired: 'Trường này không được để trống',
            minLength: 'Trường này phải chứa tối thiểu {{minLength}} ký tự',
            confirmPasswordNotMatch: 'Xác nhận mật khẩu không khớp',
            invalidQRCode:
                'Mã QRCode không hợp lệ, vui lòng scan lại mã QRCode',
            unSupportDevice: 'Thiết bị không hỗ trợ!',
            unSupportService: 'Dịch vụ không hỗ trợ!',
            dataNotFound: 'Không tìm thấy dữ liệu yêu cầu',
            alreadyScan: 'Bạn đang đặt bàn khác nên không thể đặt bàn mới này nữa!'
        },
        addressMgr: {
            title: 'Quản lý địa chỉ',
            titleAdd: 'Thêm địa chỉ',

            lbEmptyAddress: 'Chưa có địa chỉ',
            lbStreet: 'Đường',
            lbAddressNumber: 'Số nhà',
            lbZipCode: 'Mã bưu điện',
            lbCity: 'Thành phố',
            lbFloor: 'Tầng tòa nhà',
            lbAddress: 'Địa chỉ',
            lbPhone: 'Điện thoại',

            btnAddAddress: 'Thêm địa chỉ',
            btnAdd: 'Thêm',
            btnUpdate: 'Cập nhật',
            btnCancel: 'Hủy',
            btnEdit: 'Chỉnh sửa',
            btnDelete: 'Xóa',
            btnAgree: 'Đồng ý',

            lbConfirmDelete: 'Bạn có chắc chắn muốn xóa?',

            mesAddressInvalid: 'Địa chỉ không hợp lệ',
            mesUpdateAddressFailed: 'Cập nhật thất bại',
        },
        tableQrcodeSuccess: {
            continueOrder: 'Đặt tiếp',
            viewOrder: 'Xem lại',
            supporter: 'Nhân viên hỗ trợ',
            requestPayment: 'Gọi tính tiền',

            mesSubmitOrderFirst: 'Vui lòng đặt hàng rồi mới yêu cầu tính tiền',

            btnAgreeReqPmt: 'Đồng ý',
            btnCancel: 'Huỷ',
        },
        tableQrcodePrinter: {
            title: 'Printers'
        },
        apiMessage: {
            registerFailed:
                'Đăng ký không thành công, vui lòng kiểm tra lại thông tin',
            requestForgetPasswordFailed:
                'Yêu cầu quên mật khẩu không thành công, vui lòng kiểm tra lại thông tin',
            changePasswordSuccess: 'Cập nhật mật khẩu thành công',
            changePasswordFailed:
                'Cập nhật mật khẩu không thành công, vui lòng kiểm tra lại thông tin',
            updateProfileFailed:
                'Cập nhật thông tin không thành công, vui lòng kiểm tra lại.',
            customerRequestPaymentFailed:
                'Gửi yêu cầu tính tiền không thành công, vui lòng thử lại',
            loginFailed:
                'Đăng nhập không thành công, vui lòng kiểm tra lại tài khoản',
            saveOrderFailed:
                'Tạo đơn hàng không thành công, vui lòng kiểm tra thông tin và thử lại',
            undefinedError: 'Lỗi không xác định',
            orderInvalid: 'Đơn hàng không hợp lệ.',
            orderExpired: 'Đơn hàng đã hết hạn, vui lòng đặt lại.',
            getOrderDetailsFailed: 'Không tìm thấy thông tin đơn hàng',

            userAlreadyExist: 'Tên đăng nhập đã tồn tại!',
        },
    },
}
